// // components/OrderFilter.js
// import React from "react";

// const OrderFilter = ({ orderTabs, activeStatus, onChange }) => {
//     return (
//         <div className="filter-row">
//             {orderTabs.map((filter) => (
//                 <button
//                     key={filter.label}
//                     className={`filter-btn ${activeStatus === filter.status ? "active" : ""}`}
//                     onClick={() => onChange(filter.status)}
//                 >
//                     {filter.icon} {filter.label}
//                 </button>
//             ))}
//         </div>
//     );
// };

// export default OrderFilter;

import React from "react";
import "./OrderFilter.css";

const OrderFilter = ({ orderTabs, activeStatus, onChange }) => {
    return (
        <div className="order-filter">
            {orderTabs.map((filter) => (
                <div
                    key={filter.label}
                    className={`tab-item ${activeStatus === filter.status ? "active" : ""}`}
                    onClick={() => onChange(filter.status)}
                >
                    <div className="tab-icon">{filter.icon}</div>
                    <div className="tab-label">{filter.label}</div>
                </div>
            ))}
        </div>
    );
};

export default OrderFilter;
